import { Injectable } from '@angular/core';
import { LevelDto } from '../../certificates/legacy-progress-service/level-dto';
import { HttpClient, HttpParams } from '@angular/common/http';
import { OeAppService } from '../../shared/oe-app.service';
import { Store } from '../../shared/store';

@Injectable()
export class PreviousLevelsPageService extends Store<LevelDto[]> {
  constructor(private http: HttpClient, private oeAppService: OeAppService) {
    super([]);
  }

  getSelectedIndustry() {
    return this.oeAppService.getData('industry');
  }

  updatePreviousLevels() {
    const params: HttpParams = new HttpParams().set(
      'contactId',
      this.oeAppService.getPersonData().contactId
    );

    this.http
      .get<LevelDto[]>(
        `${this.oeAppService.courseServiceHost}/v1/levels/previous-levels`,
        { params }
      )
      .subscribe((levels: LevelDto[]) => this.setState(levels.reverse()));
  }
}



// WEBPACK FOOTER //
// ./ts/app/industry-content/previous-levels-page/previous-levels-page.service.ts